import { ScrollHelper } from "../util/scroll_helper";
import { BreakPoint } from "../util/breakpoint";

export class FixedSidebar {
  private readonly $side: JQuery;
  private readonly $main: JQuery;
  private readonly $sideContent: JQuery;
  private readonly spMaxWidth: number;

  constructor() {
    this.$side = $(".js-jg-content-side");
    this.$sideContent = $(".js-jg-side-content");
    this.$main = $(".js-jg-content-main");
    this.spMaxWidth = BreakPoint.JigyoshoDetailSPMaxWidth;
  }

  public init(): void {
    if (this.$main.length == 0) {
      return;
    }

    $(window).on("scroll resize", () => {
      this.updateSidePosition();
    });

    this.updateSidePosition();
  }

  private updateSidePosition(): void {
    if (this.isSP()) {
      this.cleatStyle(); // PCからSPへresize時にPC設定したCSSをリセットする
      return;
    }

    if(this.$sideContent.outerHeight() < window.innerHeight) {
      return;
    }

    const scrollBottom = ScrollHelper.currentScrollBottom();
    const contentBottom = this.$main.offset().top + this.$sideContent.outerHeight();
    const mainBottom = this.$main.offset().top + this.$main.outerHeight();

    if (scrollBottom <= contentBottom) {
      this.cleatStyle();
      this.$sideContent.css("position", "static");
    }
    else if (scrollBottom > contentBottom && scrollBottom < mainBottom) {
      this.$side.css("position", "fixed");
      this.$side.css("bottom", "0");
      const right = (window.innerWidth - this.$side.parent().width()) / 2;
      this.$side.css("right", `${right}px`);
      this.$sideContent.css("position", "static");
    } else if (scrollBottom >= mainBottom) {
      this.cleatStyle();
    }
  }

  private isSP(): boolean {
    return window.innerWidth <= this.spMaxWidth;
  }

  private cleatStyle(): void {
    this.$side.css("position", "");
    this.$side.css("bottom", "");
    this.$side.css("right", "");
    this.$sideContent.css("position", "sticky");
  }
}
